import { Row, Col } from "antd";

import useEvents from "../../api/hooks/useEvents";
import useWindowSize from "../../hooks/useWindowSize";
import EventsLogTable from "../Events/EventsLogTable/EventsLogTable";
import Alarms from "./Alarms/Alarms";
import WaterConsumptionA from "./Charts/WaterConsumptionA";
import WaterConsumptionB from "./Charts/WaterConsumptionB";

function Dashboard() {
  const window = useWindowSize();
  const { data: events, status } = useEvents(
    { pageSize: 3, startIndex: 0 },
    {
      cacheTime: 0,
    },
    "getEventsOnDashboardPage",
  );

  return (
    <>
      {window?.width > 992 && <h1 className="page-title mb-6">Dashboard</h1>}
      <Row gutter={[30, 0]} className="mb-4 sm:mb-6">
        <Col xs={24}>
          <Alarms />
        </Col>
      </Row>
      <Row className="mb-6">
        <Col xs={24}>
          <EventsLogTable
            data={events}
            status={status}
            noPagination
            withHeader
          />
        </Col>
      </Row>
      <Row gutter={10}>
        <Col
          xs={24}
          md={12}
          lg={12}
          xl={8}
          className="text-triple-white w-full my-1"
        >
          <WaterConsumptionA />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={12}
          xl={8}
          className="text-triple-white w-full my-1"
        >
          <WaterConsumptionB />
        </Col>
      </Row>
    </>
  );
}

export default Dashboard;
